import { render } from "./SectionCta.vue?vue&type=template&id=785ccfd6"
import script from "./SectionCta.vue?vue&type=script&lang=js"
export * from "./SectionCta.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__